import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, YoutubeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-900 text-white pt-16 pb-8 border-t border-slate-800" data-id="element-303">
      <div className="container mx-auto px-4" data-id="element-304">
        {/* Medical Disclaimer Banner */}
        <div className="bg-slate-800 border border-slate-700 rounded-2xl p-6 mb-12" data-id="element-305">
          <p className="text-slate-300 text-sm leading-relaxed text-center" data-id="element-306">
            <strong className="text-white" data-id="element-307">Medical Disclaimer:</strong> Nura is
            a medical tourism coordination service. We do not provide medical
            advice, diagnosis, or treatment. All medical services are provided
            by independent partner fertility clinics. Success rates and medical
            information are provided by our partner clinics for informational
            purposes only. Individual results may vary. Please consult qualified
            healthcare professionals before making treatment decisions.{' '}
            <Link to="/medical-disclaimer" className="text-blue-400 hover:text-blue-300 underline" data-id="element-308">
              Read full disclaimer
            </Link>
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-309">
          <div data-id="element-310">
            <h3 className="text-3xl tracking-wide mb-4 relative inline-block" style={{
            fontFamily: 'Syne'
          }} data-id="element-311">
              <span className="font-light italic" data-id="element-312">Nura</span>
            </h3>
            <p className="text-slate-400 mb-6 leading-relaxed font-light" data-id="element-313">
              Coordinating fertility treatment journeys at premier European
              clinics with comprehensive legal, travel, and administrative
              support.
            </p>
            <div className="flex space-x-3" data-id="element-314">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-slate-800 hover:bg-blue-600 p-2 rounded-lg transition-all hover:scale-110" data-id="element-315">
                <FacebookIcon size={20} className="text-slate-400 hover:text-white transition-colors" data-id="element-316" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="bg-slate-800 hover:bg-blue-600 p-2 rounded-lg transition-all hover:scale-110" data-id="element-317">
                <TwitterIcon size={20} className="text-slate-400 hover:text-white transition-colors" data-id="element-318" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-slate-800 hover:bg-blue-600 p-2 rounded-lg transition-all hover:scale-110" data-id="element-319">
                <InstagramIcon size={20} className="text-slate-400 hover:text-white transition-colors" data-id="element-320" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="bg-slate-800 hover:bg-blue-600 p-2 rounded-lg transition-all hover:scale-110" data-id="element-321">
                <LinkedinIcon size={20} className="text-slate-400 hover:text-white transition-colors" data-id="element-322" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="bg-slate-800 hover:bg-blue-600 p-2 rounded-lg transition-all hover:scale-110" data-id="element-323">
                <YoutubeIcon size={20} className="text-slate-400 hover:text-white transition-colors" data-id="element-324" />
              </a>
            </div>
          </div>
          <div data-id="element-325">
            <h3 className="text-lg font-bold mb-4 text-white" data-id="element-326">Quick Links</h3>
            <ul className="space-y-2" data-id="element-327">
              <li data-id="element-328">
                <Link to="/" className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-329">
                  Home
                </Link>
              </li>
              <li data-id="element-330">
                <Link to="/clinics" className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-331">
                  Partner Clinics
                </Link>
              </li>
              <li data-id="element-332">
                <Link to="/packages" className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-333">
                  Treatment Packages
                </Link>
              </li>
              <li data-id="element-334">
                <Link to="/treatments" className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-335">
                  Treatments
                </Link>
              </li>
              <li data-id="element-336">
                <Link to="/about" className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-337">
                  About & Services
                </Link>
              </li>
              <li data-id="element-338">
                <Link to="/contact" className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-339">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-340">
            <h3 className="text-lg font-bold mb-4 text-white" data-id="element-341">Legal</h3>
            <ul className="space-y-2" data-id="element-342">
              <li data-id="element-343">
                <Link to="/medical-disclaimer" className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-344">
                  Medical Disclaimer
                </Link>
              </li>
              <li data-id="element-345">
                <Link to="/privacy-policy" className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-346">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-347">
                <Link to="/terms-of-service" className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-348">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-349">
                <Link to="/cookie-policy" className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-350">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-351">
            <h3 className="text-lg font-bold mb-4 text-white" data-id="element-352">Contact</h3>
            <address className="not-italic text-slate-400 space-y-2" data-id="element-353">
              <p data-id="element-354">Prague, Czech Republic</p>
              <p data-id="element-355">
                Email:{' '}
                <a href="mailto:info@nurahealth.eu" className="hover:text-blue-400 transition-colors" data-id="element-356">
                  info@nurahealth.eu
                </a>
              </p>
            </address>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-8" data-id="element-357">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-358">
            <p className="text-slate-500 text-sm mb-4 md:mb-0" data-id="element-359">
              &copy; {new Date().getFullYear()} Nura Health. All rights
              reserved. Nura Health is a medical tourism coordination service
              and does not provide medical services.
            </p>
            <div className="flex space-x-6" data-id="element-360">
              <Link to="/privacy-policy" className="text-slate-500 hover:text-blue-400 text-sm transition-colors" data-id="element-361">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-slate-500 hover:text-blue-400 text-sm transition-colors" data-id="element-362">
                Terms of Service
              </Link>
              <Link to="/medical-disclaimer" className="text-slate-500 hover:text-blue-400 text-sm transition-colors" data-id="element-363">
                Disclaimers
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}